export default "__VITE_ASSET__DUMrAsJt__"